import { useMemo } from 'react';
import { LocalVariantSortingField } from '../../../api/types';
import makeGetSortingRule from '../../../utilities/makeGetSortingRule';

export const getSortField = makeGetSortingRule((field): LocalVariantSortingField => {
    switch (field) {
        case 'module.company.displayName':
            return LocalVariantSortingField.Company;

        case 'identifier':
            return LocalVariantSortingField.Identifier;
        case 'name':
            return LocalVariantSortingField.Name;
        case 'isActive':
            return LocalVariantSortingField.IsActive;
        case 'modelId':
            return LocalVariantSortingField.ModelId;
        case 'model':
            return LocalVariantSortingField.ModelName;
        case 'submodel.name.defaultValue':
            return LocalVariantSortingField.SubmodelName;
        case 'vehiclePrice':
            return LocalVariantSortingField.Price;
        case 'order':
            return LocalVariantSortingField.Order;

        default:
            throw new Error('Unknown Sorting Field!');
    }
});

const useSortOrder = sort => {
    const companySort = useMemo(
        () => (sort.field === LocalVariantSortingField.Company ? sort.orderValue : undefined),
        [sort]
    );

    const identifierSort = useMemo(
        () => (sort.field === LocalVariantSortingField.Identifier ? sort.orderValue : undefined),
        [sort]
    );

    const nameSort = useMemo(
        () => (sort.field === LocalVariantSortingField.Name ? sort.orderValue : undefined),
        [sort]
    );

    const activeSort = useMemo(
        () => (sort.field === LocalVariantSortingField.IsActive ? sort.orderValue : undefined),
        [sort]
    );

    const modelIdSort = useMemo(
        () => (sort.field === LocalVariantSortingField.ModelId ? sort.orderValue : undefined),
        [sort]
    );

    const modelSort = useMemo(
        () => (sort.field === LocalVariantSortingField.ModelName ? sort.orderValue : undefined),
        [sort]
    );

    const subModelSort = useMemo(
        () => (sort.field === LocalVariantSortingField.SubmodelName ? sort.orderValue : undefined),
        [sort]
    );
    const priceSort = useMemo(
        () => (sort.field === LocalVariantSortingField.Price ? sort.orderValue : undefined),
        [sort]
    );

    const orderSort = useMemo(
        () => (sort.field === LocalVariantSortingField.Order ? sort.orderValue : undefined),
        [sort]
    );

    return {
        companySort,
        nameSort,
        identifierSort,
        subModelSort,
        modelIdSort,
        modelSort,
        orderSort,
        priceSort,
        activeSort,
    };
};

export default useSortOrder;
